import { Component, Input } from '@angular/core';
import { CoordonneesEtudiantForm } from '../../models/contactForm.model';
import { ContactFormService } from '../../services/contactForm.service';

@Component({
  selector: 'app-contact-candidat',
  templateUrl: './contact-candidat.component.html',
  styleUrls: ['./contact-candidat.component.scss']
})
export class ContactCandidatComponent {
  @Input() id_instance: number;
  displayCard = true;
  isSent = false;
  isSendingForm = false;
  coordonneesEtudiantForm = new CoordonneesEtudiantForm();
  error = '';

  constructor(
    private contactFormService: ContactFormService,
  ) { }

  toggleCard() {
    this.isSent = false;
    this.displayCard = !this.displayCard;
  }

  verifForm() {
    this.error = '';
    console.log(this.coordonneesEtudiantForm)
    this.coordonneesEtudiantForm.id_instance = this.id_instance;
    if (!this.coordonneesEtudiantForm.telephone || this.coordonneesEtudiantForm.telephone === '') {
        this.error = 'Veuillez entrer votre numéro de téléphone svp.';
        return;
    } else {
        const regex = /^(0|\+33|0033)[1-9][0-9]{8}$/;
        if (!regex.test(this.coordonneesEtudiantForm.telephone)) {
            this.error = 'Veuillez entrer un numéro de téléphone valide svp.';
            return;
        }
    }
    if (!this.coordonneesEtudiantForm.email || this.coordonneesEtudiantForm.email === '') {
        this.error = 'Veuillez entrer votre adresse mail svp.';
        return;
    } else {
        const regex = /^[a-zA-Z0-9._-]+@[a-z0-9._-]{2,}\.[a-z]{2,4}$/;
        if (!regex.test(this.coordonneesEtudiantForm.email)) {
            this.error = 'Veuillez entrer une adresse mail valide svp.';
            return;
        }
    }

    // If we didn't get any error, then we send the form
    this.sendForm();
}

sendForm() {
    this.isSendingForm = true;
    this.contactFormService.sendCoordonneesEtudiantForm(this.coordonneesEtudiantForm).subscribe(
        (res: any) => {
            this.isSent = true;
            this.isSendingForm = false;
        },
        (err) => {
            this.error = 'Une erreur est survenue lors de l\'envoi du formulaire. Veuillez vérifier les informations saisies svp.\n Si toutefois l\'erreur persiste, veuillez nous contacter svp.';
            console.log(err);
            this.isSendingForm = false;
        }
    );
}

}
